import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import SubNavigationItems from "go-app/components/Navigation/SubNavigationItems";
import { UserRole } from "../../../../../services/Api/types";
import { hasRole } from "../../../../../services/users/selectors";

const AdminNavigation = (props: RouteComponentProps) => {
	const { t } = useTranslation("admin");
	const prefixUrl = "/admin";
	const hasAdminRole = useSelector(hasRole(UserRole.ADMIN));
	const hasOfficeRole = useSelector(hasRole(UserRole.OFFICE));
	const hasPosnetRole = useSelector(hasRole(UserRole.POSNET));
	const hasItSupportRole = useSelector(hasRole(UserRole.IT_SUPPORT));
	const hasSupportRole = useSelector(hasRole(UserRole.SUPPORT));
	const hasSaleTlRole = useSelector(hasRole("SALE_TL"));
	const hasCsTlRole = useSelector(hasRole("CS_TL"));
	const hasCsvTlRole = useSelector(hasRole("CSV_TL"));

	const items = [
		{
			title: t("modules.dashboard.header.title"),
			route: `${prefixUrl}`,
			isActiveRoute: () => props.location.pathname.split("/").length === 2,
			hide: !(hasAdminRole || hasOfficeRole),
		},
		{
			title: t("modules.organization.header.title"),
			route: `${prefixUrl}/organizations`,
			hide: !(hasAdminRole || hasOfficeRole || hasSaleTlRole || hasCsTlRole),
		},
		{
			title: t("common.word.users", { ns: "lib" }),
			route: `${prefixUrl}/users`,
			hide: !(hasAdminRole || hasOfficeRole),
		},
		{
			title: t("common.word.partners"),
			route: `${prefixUrl}/partners`,
			hide: !(hasAdminRole || hasOfficeRole),
		},
		{
			title: t("common.word.applications"),
			route: `${prefixUrl}/apps`,
			hide: !hasAdminRole,
		},
		{
			title: t("modules.app_version.header.title"),
			route: `${prefixUrl}/app_versions`,
			hide: !(hasAdminRole || hasOfficeRole || hasItSupportRole || hasSupportRole),
		},
		{
			title: t("modules.tool.header.title"),
			route: `${prefixUrl}/tools`,
			hide: !hasAdminRole,
		},
		{
			title: t("modules.crash_report.header.title"),
			route: `${prefixUrl}/crash_reports`,
			hide: !(hasAdminRole || hasItSupportRole),
		},
		{
			title: t("lib:common.word.logs"),
			route: `${prefixUrl}/file_logs`,
			hide: !(hasAdminRole || hasItSupportRole),
		},
		{
			title: t("lib:go_component.custom_field.header.title"),
			route: `${prefixUrl}/custom_fields`,
			hide: !hasAdminRole,
		},
		{
			title: t("modules.terminal.header.title"),
			route: `${prefixUrl}/terminals`,
			hide: !hasAdminRole,
		},
		{
			title: t("modules.payoff.header.title"),
			route: `${prefixUrl}/payoff`,
			hide: !(hasAdminRole || hasOfficeRole),
		},
		{
			title: t("modules.partner_payout_invoice.header.title"),
			route: `${prefixUrl}/partner_payout_invoices`,
			hide: !(hasAdminRole || hasOfficeRole),
		},
		{
			title: t("modules.transaction.header.title"),
			route: `${prefixUrl}/transactions`,
			hide: !(hasAdminRole || hasOfficeRole),
		},
		{
			title: t("modules.access.header.title"),
			route: `${prefixUrl}/accesses`,
			hide: !(hasAdminRole || hasOfficeRole),
		},
		{
			title: t("modules.loan.header.title"),
			route: `${prefixUrl}/loans`,
			hide: !(hasAdminRole || hasOfficeRole || hasPosnetRole),
		},
		{
			title: t("modules.go_launcher.header.applications.title"),
			route: `${prefixUrl}/go_launcher/applications`,
			hide: !hasAdminRole,
		},
		{
			title: t("modules.go_launcher.header.categories.title"),
			route: `${prefixUrl}/go_launcher/categories`,
			hide: !hasAdminRole,
		},
	];

	return <SubNavigationItems title={t("modules.admin.header.title")} items={items} />;
};

export default AdminNavigation;
